import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { HTTP_VERBS } from 'utils/constants';
import { ALERT_VARIANTS, LOCALIZATION_PAGES } from 'utils/constants';
import { useRoot } from 'context/RootContext';

const useBulkDeleteUsers = deleteList => {
  const path = '/users/bulk-delete';
  const { t } = useTranslation(LOCALIZATION_PAGES.USER_PROFILE);
  const { showNotification } = useRoot();
  const [{ result, loading, error }, deleteUsers] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.POST,
    data: deleteList,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (result) {
      showNotification({
        message: t('success'),
      });
    }
  }, [result, showNotification, t]);

  return [{ result, loading }, deleteUsers];
};

export default useBulkDeleteUsers;
